module.exports = __webpack_public_path__ + "img/A.48914175.svg";